
export const VocabProToPatient = {
    //  Title
    'pro_onboarding_title': ['Completemos tu perfil', "Let's complete your profile"],
    'pro_onboarding_message': ['Para usar la funciones de pacientes necesitamos que completar tu informacion.', 
        "To use the patient features, we need you to complete your information.."],
    'confidentiality_legend': ['Toda la informacion recabada es confidencial y esta protegida de acuerdo con nuestras', 
        'All gathered data is confidential and is protected under our'],
    'confidentiality_link': ['politicas de privacidad', 'privacy policies'],
    /*  Step 0 Welcome instructions   */
    'welcome_title': ["Creemos tu perfil clinico", "Let's create your clinical profile!"],
    'welcome_intro': ['Este formulario nos ayudara a cubrir los basicos de tu perfil.', 
        'This will help us cover the basics of your profile.'],

    'time_label': ["Tiempo estimado:", "Estimated time:"],
    'time_value': ["5 - 7 minutos", "5 - 7 minutes"],
    'prep_title': ["Te haremos preguntas acerca de:", "We will ask you questions about:"],
    'physique': ["Tu físico", "Your physique"],
    'substance_use': ["Uso de sustancias", "Substance use"],
    'habits': ["Hábitos", "Habits"],
    

    'resume': ["Puedes guardar tu progreso y continuar después si lo necesitas.", 
        "You can save your progress and continue later if needed."],

    '': ['', ''],
  }
